import { useEffect, useState } from "react";
import { api } from "./api";

export const useGamesPaused = () => {
  const [paused, setPaused] = useState(true);
  useEffect(() => { api.get("/stb/public-status").then((r) => setPaused(r.data.paused)).catch(() => {}); }, []);
  return paused;
};

export const SOON_TEXT = "Fundraiser games are coming soon – we're putting the finishing touches to payments.";
